import React, { Component } from 'react';
import { Spin, Button, Select, DatePicker } from 'antd';
import API_URL from '../../common/url';
import TableC from '../basicElement/TableC';
import DateRange from '../common/DateRange.new.js';
import SideNav from './SumEffSider';
import Highcharts from 'react-highcharts';
import chartsConfig from '../common/chartsConfig';
import $ from '../../common/AjaxRequest';
import dictCache from '../../common/dictCache';
import moment from 'moment';

const Option = Select.Option;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

class Charts extends Component {
    render() {
        const { title, chartConfig, searchBar } = this.props;
        const { format, tooltip = {}, series, categories } = chartConfig;
        const config = {
            title: {
                text: ''
            },
            chart: {
                type: 'line'
            },
            legend: {
                align: 'right',
                verticalAlign: 'top',
                x: 0,
                y: 20,
                layout: 'vertical',
            },
            tooltip,
            yAxis: [{
                title: {
                    text: ''
                },
            }, {
                title: {
                    text: ''
                },
                opposite: true,
                labels: {
                    format,
                },
            }],
            xAxis: {
                categories,
            },
            series,
            exporting: {
                chartOptions: {
                    plotOptions: {
                        series: {
                            dataLabels: {
                                enabled: true
                            }
                        }
                    }
                }
            },
            plotOptions: {
                series: {
                    animation: false
                }
            },
            credits: {
                enabled: false,
                text: 'SMO医疗大数据',
            },
        };
        return (
            <div>
                <div className="T-tit">
                    <div className="txt">
                        <h3 style={{ marginBottom: 10 }}>{title}</h3>
                    </div>
                </div>
                {searchBar}
                <div className="charts" style={{ marginBottom: 20 }}>
                    <Highcharts config={{ ...config, ...chartsConfig }} />
                </div>
            </div>
        )
    }
}

class Efficiency extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            dataList: [],
            categories: [],
            typeName: {},
            tableData: {},
            investigationSiteList: [],
            investigationList: [],
            totalPlanFTE: '',
            totalPlanVisit: '',
            investigations: [],
            invSite: [],
            searchParams: {
                begin: moment().subtract(sessionStorage.curRole === 'CRC' ? 3 : 11, 'M').format(monthFormat),
                end: moment().format(monthFormat),
            },
            currentDate: '',
            beginOpen: false,
            endOpen: false,
        };
    }

    componentDidMount() {
        this.loadData();
        this.getDate();
        if (this.props.crcUserId) {
            this.loadInvList()
        }
        chartsConfig.exporting.buttons.contextButton.menuItems = [
            'downloadJPEG', 'downloadPDF', 'downloadPNG', 'downloadSVG',
        ];
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.visible && this.props.visible) {
            this.setState({
                searchParams: {
                    begin: moment().subtract(sessionStorage.curRole === 'CRC' ? 3 : 11, 'M').format(monthFormat),
                    end: moment().format(monthFormat),
                },
                investigationSiteList: [],
            }, () => {
                this.loadData();
                this.loadInvList();
            });
        }
    }

    // 获取系统时间
    getDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { date } = res;
            this.setState({ currentDate: date });
        });
    }

    disabledDate = (current) => {
        const { currentDate } = this.state;
        const startOfRange = moment(currentDate).subtract(3, 'months').startOf('month');
        const endOfRange = moment(currentDate).endOf('month');
        return current < startOfRange || current > endOfRange;
    }

    handleChange = (date, dateString, type) => {
        const { searchParams } = this.state;
        const num = sessionStorage.curRole === 'CRC' ? 3 : 11;
        const { begin, end } = searchParams;
        if (type === 'begin') {
            searchParams.begin = dateString;
            if (end && moment(dateString).valueOf() < moment(end).subtract(num, 'M').valueOf()) {
                searchParams.end = moment(dateString).add(num, 'M').format(monthFormat);
            }
            this.setState({ endOpen: true });
        } else {
            searchParams.end = dateString;
            if (begin && moment(dateString).valueOf() > moment(begin).add(num, 'M').valueOf()) {
                searchParams.begin = moment(dateString).subtract(num, 'M').format(monthFormat);
            }
        }
        this.setState({ searchParams });
    }

    handleOpenChange = (status, type) => {
        if (type === 'begin') {
            this.setState({ beginOpen: status });
        } else {
            this.setState({ endOpen: status });
        }
    }

    loadData = () => {
        const { crcUserId, type } = this.props;
        const { searchParams } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.manhour.queryEfficiency,
            data: {
                type,
                crcUserId,
                relatedUser: crcUserId ? 1 : 0,
                ...searchParams,
            },
            dateType: 'json',
            doneResult: res => {
                const { dataList, monthList, typeName, tableData, totalPlanFTE, totalPlanVisit, } = res.data;
                const categories = monthList.map(i => `${i.month}月`);
                this.setState({
                    loading: false,
                    dataList,
                    categories,
                    typeName,
                    tableData,
                    totalPlanFTE,
                    totalPlanVisit,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    loadInvList = () => {
        const { crcUserId } = this.props;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryUserInvestigationList,
            data: {
                offset: 1,
                limit: 15,
                userId: crcUserId,
            },
            dataType: 'json',
            doneResult: data => {
                this.setState({ investigations: data.data.investigations });
            }
        };
        $.sendRequest(options);
    }

    loadInvSiteList = () => {
        const { crcUserId } = this.props;
        const { searchParams: { investigationId } } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.site.queryUserSiteList,
            data: {
                offset: 1,
                limit: 15,
                userId: crcUserId,
                investigationId,
            },
            dataType: 'json',
            doneResult: data => {
                this.setState({ invSite: data.data.siteList });
            }
        };
        $.sendRequest(options);
    }

    getDataSource = () => {
        const { crcUserId } = this.props;
        const { typeName, tableData, categories } = this.state;
        const { siteId } = sessionStorage;

        const typeList = ['planFte', 'usedFte', 'userFteCumulative', 'finishVisit', 'finishVisitCumulative', 'finishVisitDipFte'];
        if (siteId == 0) {
            const len = typeList.length;
            if (!crcUserId) {
                typeList.splice(len - 1, 0, 'finishVisitCumulativePercent');
            } else {
                typeList.splice(len - 1, 0, 'siteMonthCrcFte', 'monthVisitStandardAmount', 'cumulativeVisitStandardAmount');
            }
        }
        const dataSource = [];
        typeList.forEach(type => {
            const row = {};
            if (tableData[type]) {
                tableData[type].forEach((data, j) => {
                    if (type == 'finishVisitCumulativePercent') {
                        row[categories[j]] = `${data}%`
                    } else if (type == 'usedManHour') {
                        row[categories[j]] = Number(data);
                    } else {
                        row[categories[j]] = Number(data.toFixed(2));
                    }
                });
                dataSource.push({
                    title: typeName[type],
                    ...row,
                });
            }
        });
        return dataSource;
    }

    getColumns = () => {
        const { categories } = this.state;
        const columns = [{
            title: '',
            dataIndex: 'title',
            key: 'title',
            width: 160,
        }];
        categories.forEach(d => {
            columns.push({
                title: d,
                dataIndex: d,
                key: d,
            });
        });
        return columns;
    }

    handleSelectChange = (value, key) => {
        const { searchParams } = this.state;
        if (key === 'investigationId') {
            searchParams.investigationId = value;
            searchParams.investigationSiteId = undefined;
            this.setState({ searchParams }, () => {
                value && this.loadInvSiteList();
            })
        } else {
            searchParams[key] = value;
            this.setState({ searchParams });
        }
    }

    handleDateChange = (value) => {
        const { searchParams } = this.state;
        const [begin, end] = value;
        searchParams.begin = begin;
        searchParams.end = end;
        this.setState({ searchParams });
    }

    getSearchBar = (showSearch, crcUserId) => {
        const { investigations, invSite, searchParams, beginOpen, endOpen } = this.state;
        const { begin, end, investigationId, investigationSiteId } = searchParams;
        const invoption = investigations.map(d => <Option key={d.investigationId}>{d.investigationName}</Option>);
        const siteoption = invSite.map(d => <Option key={d.investigationSiteId}>{d.investigationSiteName}</Option>);
        return (
            (crcUserId || showSearch) &&
            <div style={{ textAlign: crcUserId ? 'left' : 'center', width: '80%', marginBottom: 10 }}>
                <div style={{display: 'inline-block'}}>
                    <MonthPicker
                        style={{verticalAlign: 'middle', width: 100 }}
                        open={beginOpen}
                        allowClear={false}
                        value={begin ? moment(begin) : null}
                        disabledDate={sessionStorage.curRole == 'CRC' ? this.disabledDate : false}
                        onOpenChange={status => this.handleOpenChange(status, 'begin')}
                        onChange={(date, dateString) => this.handleChange(date, dateString, 'begin')}
                    />
                    <span className="ant-divider" style={{margin: '0 10px'}} />
                    <MonthPicker
                        style={{verticalAlign: 'middle', width: 100 }}
                        open={endOpen}
                        allowClear={false}
                        value={end ? moment(end) : null}
                        disabledDate={sessionStorage.curRole == 'CRC' ? this.disabledDate : false}
                        onOpenChange={status => this.handleOpenChange(status, 'end')}
                        onChange={(date, dateString) => this.handleChange(date, dateString, 'end')}
                    />
                </div>
                {
                    crcUserId &&
                    <div style={{ display: 'inline-block' }}>
                        <span className="ant-divider" />
                        <Select
                            style={{ width: 180 }}
                            placeholder="请选择"
                            value={investigationId}
                            allowClear={true}
                            onChange={value => this.handleSelectChange(value, 'investigationId')}
                        >
                            {invoption}
                        </Select>
                        <span className="ant-divider" />
                        <Select
                            style={{ width: 180 }}
                            placeholder="请选择"
                            allowClear={true}
                            disabled={!investigationId}
                            value={investigationSiteId}
                            onChange={value => this.handleSelectChange(value, 'investigationSiteId')}
                        >
                            {siteoption}
                        </Select>
                    </div>
                }
                <span className="ant-divider" />
                <Button type='primary' onClick={this.loadData}>统计</Button>
            </div>
        )
    }
 
    render() {
        const { totalPlanFTE, totalPlanVisit, loading, categories, typeName, tableData } = this.state;
        const { crcUserId } = this.props;
        const { siteId } = sessionStorage;
        const isCenter = siteId == 0;

        const proSeriesData = [{
            data: tableData.finishVisitDipFte || [],
            name: crcUserId ? `每月完成标准访视数/<br/>每月CRC项目确认FTE` : `每月完成访视数/<br/>每月消耗FTE数`,
        }]
        const seriesData2 = [{
            data: tableData.finishVisitCumulative || [],
            name: typeName.finishVisitCumulative,
        }, {
            data: tableData.userFteCumulative ? tableData.userFteCumulative.map(d => d) : [],
            name: typeName.userFteCumulative,
            yAxis: 1,
        }, {
            data: categories.map(d => totalPlanFTE),
            name: '总计划FTE数',
            yAxis: 1,
        }, {
            data: categories.map(d => totalPlanVisit),
            name: '总计划访视数',

        }];
        const proChartConfig = {
            format: '{value}',
            categories,
            series: seriesData2,
        };
        const chartConfig2 = {
            format: '{value} %',
            tooltip: {
                formatter: function () {
                    const yValue = this.y;
                    return '' + this.series.name + '<br/>' +
                        this.x + ': ' + '<b>' + Number(yValue.toFixed(2)) + '</b>';
                }
            },
            categories,
            series: proSeriesData,
        };
        return (
            <div className="content">
                {!crcUserId && <SideNav selectKey='efficiency' />}
                <div className="main">
                    <Spin spinning={loading}>
                        {
                            (isCenter && !crcUserId) &&
                            <Charts
                                title="累计完成访视数VS.累计消耗FTE数"
                                chartConfig={proChartConfig}
                                searchBar={this.getSearchBar(true, crcUserId)}
                            />
                        }
                        <Charts
                            title={crcUserId ? "每月完成标准访视数VS每月CRC项目确认FTE" : "每月完成访视数VS.每月消耗FTE数"}
                            chartConfig={chartConfig2}
                            searchBar={this.getSearchBar(!isCenter, crcUserId)}
                        />
                        <TableC
                            data={this.getDataSource()}
                            columns={this.getColumns()}
                            rowKey="title"
                            pagination={false}
                        />
                    </Spin>
                </div>
            </div>
        );
    }
}

export default Efficiency;


// WEBPACK FOOTER //
// ./src/components/sumTotal/Efficiency.js